module.exports = __webpack_public_path__ + "img/book.ab108452.svg";